import React from 'react';
import '../../styles/components/skeleton.css';

/**
 * Skeleton loader pour la liste de shows
 * @param {number} count - Nombre d'items skeleton à afficher (défaut: 5)
 */
const ShowsSkeleton = ({ count = 5 }) => {
  return (
    <div className="shows-skeleton-list">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="skeleton-show-item">
          <div className="skeleton-show-name"></div>
          <div className="skeleton-show-times">
            <div className="skeleton-show-time"></div>
            <div className="skeleton-show-time"></div>
            <div className="skeleton-show-time"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ShowsSkeleton;
